import {Loader} from "@googlemaps/js-api-loader"
//import "../../css/maps.scss"

let map = null
let markers = [];
const loadedPlaces = []
const mainColor = getComputedStyle(document.documentElement).getPropertyValue("--coing-color-main");
const bgColor = getComputedStyle(document.documentElement).getPropertyValue("--coing-color-bg");
const textColor = getComputedStyle(document.documentElement).getPropertyValue("--coing-color-text");
const plainSvgMarker = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 20\" width=\"25\" height=\"32\">" +
    "<path d=\"M15 7.90757C15 12.2748 7.5 20 7.5 20C7.5 20 0 12.2748 0 7.90757C0 3.54034 3.35786 0 7.5 0C11.6421 0 15 3.54034 15 7.90757Z\" fill=\"" + mainColor + "\"></path>" +
    "</svg>";
let selectedMarker = '';
let bounds


const makeLabel = text => {
    return {
        text: text,
        className: 'marker-label',
    }
}

export default function (context) {
    const mapExists = () => { return $(context).find('#map-canvas').length > 0; }
    const autocompleteExists = () => { return $(context).find('[data-maps-autocomplete]').length > 0; };

    const updateMarkers = tagsFilter => {
        const visible = tagsFilter.getVisible(false).map(function () {
            const location = $(this).data('location')
            if (location && location.place_id) {
                return location.place_id
            }
            return location
        }).get()
        markers.forEach(marker => {
            marker.setVisible(visible.includes(marker.referenceKey))
        })
    }

    const bindLocations = () => {
        if (!map) {
            return;
        }

        const svgMarker = {
            url: 'data:image/svg+xml;base64,' + window.btoa(plainSvgMarker),
            rotation: 0,
            labelOrigin: new google.maps.Point(7.5, 7.5),
        };
//
        if (!bounds) {
            bounds = new google.maps.LatLngBounds();
        }

        // resets all markers to unselecred
        const resetMarkers = () => {
            markers.forEach((marker) => {
                marker.setOpacity(.75);
            });
        };

        // gets marker by place_id
        const getMarker = (placeId) => {
            for (let i = 0; i < markers.length; i++) {
                if (markers[i].markerID === placeId) {
                    return markers[i];
                }
            }
            return null;
        };

        // turns marker selected / unselected
        const toggleMarker = (placeId) => {
            resetMarkers();
            const marker = getMarker(placeId);
            if (selectedMarker === placeId) {
                selectedMarker = '';
                return false;
            } else {
                selectedMarker = placeId;
                marker.setOpacity(1);
                return true;
            }
        };

        // creates group marker
        const createMarker = (group) => {
            const location = group.place;
            const placeId = location.place_id;
            const currentMarker = {
                url: location.markerImg,
                rotation: 0,
                labelOrigin: new google.maps.Point(7.5, 7.5),
            };
            const markerIcon = (location.markerImg != 'default') ? currentMarker : svgMarker;
            const label = group.count > 1 ? group.count.toString() : ' ';
            const marker = new google.maps.Marker({
                position: location.geometry.location,
                map: map,
                opacity: .75,
                icon: markerIcon,
                label: {
                    text: label,
                    color: 'white',
                    fontSize: '12px',
                    fontWeight: 'bold',
                },
            });
            marker.markerID = placeId;
            marker.referenceKey = placeId;
            marker.setTitle(location.label.toString());
            marker.addListener('mouseover', e => {
                //marker.setLabel(makeLabel($(this).find('h3.activity-name').text()))
            });
            marker.addListener('mouseout', e => {
                //marker.setLabel('');
            });
            marker.addListener("click", e => {
                const isOn = toggleMarker(placeId);
                if (isOn) {
                    filterListItems('activities-list', 'data-location', placeId);
                } else {
                    filterListItems('activities-list');
                }
                scrollToListItem('activities-list');
            });
            markers.push(marker);
            bounds.extend(marker.position);
        }

        // after all locations were put to groups
        const createMarkers = groupedPlaces => {
            for (var key in groupedPlaces) {
                createMarker(groupedPlaces[key]);
            }
            // re-center map
            map.fitBounds(bounds);
            map.setZoom(map.getZoom() - 1);

            const tagsFilter = $('#panel__regular-groups').data('filter')
            if (tagsFilter) {
                updateMarkers(tagsFilter)
            }
        };

        // loads place - call google api to get place by place_id
        const getApiPlace = async (placeId) => {
            return new Promise((resolve, reject) => {
                if (typeof loadedPlaces[placeId] !== 'undefined') {
                    resolve(loadedPlaces[placeId])
                }
                const service = new google.maps.places.PlacesService(map);
                service.getDetails({
                    placeId: placeId,
                    fields: ['geometry.location', 'place_id'],
                }, (place, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        loadedPlaces[placeId] = place
                        resolve(place);
                    } else {
                        reject('error');
                    }
                });
            });
        };

        // loads collected place_id places
        const loadAddressLocationsFromApi = async placesToLoad => {
            const groupedPlaces = []
            for (let placeId in placesToLoad) {
                const item = placesToLoad[placeId];
                let place
                if (item.type === 'address') {
                    place = await getApiPlace(item.address)
                } else if (item.type === 'coords') {
                    place = item.place
                }
                place.markerImg = item.element.data('icon');
                place.label = item.element.data('label');
                if (place.place_id && place.geometry) {
                    const placeId = place.place_id;
                    if (groupedPlaces[placeId]) {
                        groupedPlaces[placeId].count++
                    } else {
                        groupedPlaces[placeId] = {
                            place: place,
                            count: 1
                        }
                    }
                }
            }
            return groupedPlaces
        }

        // const  = function() {}
        // loop through locations - collect place_ids
        const initPageElements = async ($elements) => {
            let locations = []
            $elements.each(async function (i, elem) {
                const location = $(this).data('location');
                if (typeof location === 'object') {
                    if (!location.place_id) {
                        // todo: Need a proper string.
                        location.place_id = 'abc' + location.geometry.location.lat.toString() + location.geometry.location.lng.toString();
                    }
                    $(this).attr('data-location', location.place_id.toString());
                    locations.push({
                        type: 'coords',
                        place: location,
                        element: $(this),
                    })
                } else if (typeof location === 'string') {
                    locations.push({
                        type: 'address',
                        address: location,
                        element: $(this),
                    })
                }else {
                    console.warn(location)
                }
            })
            return locations
        }

        initPageElements($(context).data('location') ? $(context) : $('[data-location]', context))
            .then(loadAddressLocationsFromApi)
            .then(createMarkers)

    }

    const bindMap = () => {
        const container = $('#map-canvas:not(.processed)', context)
        if (container.length > 0) {
            container.addClass('processed')
            const dPoint = container.attr('data-point');
            const dCenter = container.attr('data-center') || dPoint;
            const arr = dCenter ? dCenter.replace('@', '').split(',') : [32, 14, 2];
            map = new google.maps.Map(container[0], {
                center: new google.maps.LatLng(Number(arr[0]), Number(arr[1])),
                zoom: Number(arr[2].toString().replace('z', '')),
                mapTypeControl: false,
                fullscreenControl: false
            })
            container.data('map', map)
        }
    }

    const bindAutocomplete = () => {
        $('[data-maps-autocomplete]:not(.processed)', context).each(function () {
            const $this = $(this)
            const options = $this.data('maps-autocomplete');
            const autocomplete = new google.maps.places.Autocomplete(this, options)
            autocomplete.addListener('place_changed', function () {
                const place = autocomplete.getPlace();
                $this.siblings('#' + $this.data('datafield'))[0].value = JSON.stringify(place);
            })
            $this.on('change', function () {
                const val = $this.val()
                $this.siblings('#' + $this.data('datafield'))[0].value = val ? JSON.stringify({full: val}) : '';
            })
            $this.addClass('processed');
        })
    }

    const bindFilter = () => {
        const tagsFilter = $('#panel__regular-groups', context).data('filter')
        if (tagsFilter && map) {
            tagsFilter.on('update', updateMarkers)
            tagsFilter.on('clear', updateMarkers)
        }
    }

    const addLegend = () => {
        const legend = document.getElementById("legend");
        let fillColor = getComputedStyle(document.documentElement).getPropertyValue("--coing-color-main");
        let plainSvgMarker = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 20\" width=\"25\" height=\"32\">" +
            "<path d=\"M15 7.90757C15 12.2748 7.5 20 7.5 20C7.5 20 0 12.2748 0 7.90757C0 3.54034 3.35786 0 7.5 0C11.6421 0 15 3.54034 15 7.90757Z\" fill=\"" + fillColor + "\"></path>" +
            "</svg>";
        let icon = 'data:image/svg+xml;base64,' + window.btoa(plainSvgMarker);
        const item = $(`<div class="legend-item" role="listitem"><img src="${icon}"> <span>place</span></div>`)
        $('#legend-markers').prepend(item)
        map.controls[google.maps.ControlPosition.LEFT_TOP].push(legend);
        setTimeout(() => {
            legend.classList.remove('opacity-0')
        }, 800);
    }

    if (context === document) {
        setTimeout(() => {
            const loader = new Loader({
                apiKey: process.env.GOOGLE_PLACES_APIKEY,
                libraries: ['places'],
                version: "weekly"
            });
            loader.load().then(() => {
                if (mapExists()) {
                    bindMap()
                    bindLocations()
                    bindFilter()
                    addLegend()
                }
                if (autocompleteExists()) {
                    bindAutocomplete()
                }
            });
        })
    } else {
        if (map) {
            bindLocations()
            bindFilter()
        }
        if (autocompleteExists()) {
            bindAutocomplete()
        }
    }

    $('button.get-location', context).on('click', function () {
        navigator.geolocation.getCurrentPosition(position => {
            const input = $($(this).data('for'))
            input.val(position.coords.latitude + ',' + position.coords.longitude)
            input.trigger('change')
        });
    })
    $('input#editgroup-locationcoords', context).on('change', function () {
        if ($(this).val()) {
            $(this).siblings('#' + $this.data('datafield')).val('');
        }
    })

    $('#legend-header', context).on('click', function () {
        const parent = $(this).toggleStrBool('aria-pressed').toggleStrBool('aria-expanded')
            .parent().toggleClass('active');
        if (parent.hasClass('active')) {
            parent.find('#legend-markers').slideDown();
        } else {
            parent.find('#legend-markers').slideUp();
        }
    })
}
